
import styled from 'styled-components'

import COLORS from 'constants/colors'
import LAYOUT from 'constants/layout'


import { Props } from './types'

const getMarginSize = (size?: 'none' | 'small' | 'medium' | 'large', margined?: boolean): string => {
  if (size) {
    switch (size) {
      case 'small':
        return '30px'
      case 'medium':
        return '60px'
      case 'large':
        return '90px'
      case 'none':
      default:
        return '0'
    }
  }

  return margined ? '60px' : '0'
}

export default styled.div<Props>`
  margin-right: auto;
  margin-left: auto;
  margin-top: ${(props: Props): string => getMarginSize(props.marginSize, props.margined)};
  margin-bottom: ${(props: Props): string => getMarginSize(props.marginSize, props.margined)};
  padding-top: ${(props: Props): string => (props.padded ? '60px' : '0')};
  padding-bottom: ${(props: Props): string => (props.padded ? '60px' : '0')};
  padding-left: ${(props: Props): string => (props.hasGutter !== false ? '20px' : '0')};
  padding-right: ${(props: Props): string => (props.hasGutter !== false ? '20px' : '0')};
  max-width: ${(props: Props): string => props.short ? `${LAYOUT.WIDTHSHORT}` : `${LAYOUT.WIDTH}`};
  display: flex;
  justify-content: ${(props: Props): string => props.justifyContent || 'center'};
  align-items: ${(props: Props): string | undefined => props.alignItems};
  flex-direction: ${(props: Props): string | undefined => props.flexDirection};
  flex-wrap: ${(props: Props): string => (props.flexNoWrap ? 'no-wrap' : 'wrap')};
  gap: ${(props: Props): string | undefined => props.gap};
  width: 100%;
  ${(props: Props): string => (props.bottomBorder && `
    border-bottom: 1px solid ${COLORS.BORDERS};
    padding-bottom: 30px;
    margin-bottom: 70px;
  `) || ''};
`
